import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import CmtImage from '@coremat/CmtImage';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs } from '@mui/material';

const useStyles = makeStyles(theme => ({
  headerRoot: {
    position: 'relative',
    margin: '-30px -30px 0 -30px',
    paddingTop: 30,
    paddingBottom: 20,
    '@media (min-width: 960px)': {
      marginTop: '-60px',
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 56,
      paddingLeft: 56,
      marginRight: 0,
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 50,
      paddingRight: 50,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 65,
      paddingRight: 65,
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 88,
      paddingRight: 88,
    },
  },
  headerBgImg: {
    position: 'absolute',
    left: 0,
    top: -20,
    width: '100%',
    height: '100%',
    minHeight: 370,
    zIndex: 0,
    [theme.breakpoints.up('sm')]: {
      minHeight: 270,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
    },
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  headerContent: {
    position: 'relative',
    zIndex: 3,
  },
  titleRoot: {
    color: theme.palette.text.white,
    marginBottom: 4,
    fontSize: '2rem',
    fontWeight: '600',
  },
  subTitleRoot: {
    color: alpha(theme.palette.common.white, 0.74),
  },
  followerList: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: -15,
    marginRight: -15,
    [theme.breakpoints.up('md')]: {
      marginLeft: -24,
      marginRight: -24,
    },
  },
  followerListItem: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'center',
    cursor: 'pointer',
    color: alpha(theme.palette.common.white, 0.74),
    fontSize: 12,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
    '&:not(:first-child)': {
      borderLeft: `solid 1px ${alpha(theme.palette.common.white, 0.38)}`,
    },
  },
  followerListTitle: {
    color: theme.palette.common.white,
    marginBottom: 3,
  },
  tabsList: {
    position: 'relative',
    minHeight: 10,
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.secondary.main,
    },
    '& :hover': {
      color: theme.palette.secondary.main,

      '& >svg': {
        color: theme.palette.secondary.main,
      },
    },
    '& .Mui-selected': {
      color: `${theme.palette.secondary.main}`,
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 10,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: 'none',
    color: theme.palette.common.white,
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Header = ({ userDetail, tabValue, handleTabChange, tabs }) => {
  const { t } = useTranslation();
  const {
    person: { firstName, lastName },
  } = userDetail;
  const classes = useStyles();
  return (
    <Box className={classes.headerRoot}>
      <Box className={classes.headerBgImg}>
        <CmtImage src={'/images/profile-bg-img.png'} />
      </Box>
      <Box className={classes.headerContent}>
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems="center" mb={4}>
          <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems="center">
            <Box>
              <Typography className={classes.titleRoot} component="div" variant="h1">
                {t('welcome')} {firstName} {lastName}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box display="flex" justifyContent={{ xs: 'center', sm: 'flex-end' }}>
          <Tabs
            className={classes.tabsList}
            value={tabValue}
            onChange={handleTabChange}
            aria-label="profile tabs"
            variant="scrollable"
            allowScrollButtonsMobile>
            {tabs.map((item, index) => {
              return <Tab className={classes.tabItem} icon={item.icon} key={item.id} value={item.id} label={item.title} />;
            })}
          </Tabs>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;

Header.prototype = {
  userDetail: PropTypes.object.isRequired,
  tabValue: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func,
};
